
import React, { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { usePageTitle } from "@/hooks/usePageTitle";
import AppSidebar from "./AppSidebar";
import PageHeader from "./PageHeader";

const DashboardLayout = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const pageTitle = usePageTitle();
  
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
    
    // Add class to help with mobile navigation interactions
    if (isMobile) {
      document.body.classList.add('has-mobile-navigation');
    }
    
    return () => {
      document.body.classList.remove('has-mobile-navigation');
    };
  }, [isAuthenticated, navigate, isMobile]);

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 overflow-auto">
          <PageHeader pageTitle={pageTitle} />
          <div className={`${isMobile ? "p-3" : "p-6"}`}>
            <Outlet />
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default DashboardLayout;
